import './remove-size-attr-from-portfolio-pods.js';

var environment = {
	isAndroid: function () {
		return navigator.userAgent.match(/Android/i);
	},
	isBlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	isIOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	isOpera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	isWindows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	isMobile: function () {
		return (environment.isAndroid() || environment.isBlackBerry() || environment.isIOS() || environment.isOpera() || environment.isWindows());
	}
};

function getBrowserWidth() {
	return Math.max(
		document.body.scrollWidth,
		document.documentElement.scrollWidth,
		document.body.offsetWidth,
		document.documentElement.offsetWidth,
		document.documentElement.clientWidth
	);
}

function toggleStickyNavigation() {
	var sticky = jQuery('.sticky-form-inside .wpb_wrapper');

	if (sticky.length == 0)
		return false;

	var navbar = jQuery('#header-outer');
	var space_between_banner_and_sticky = 65;

	jQuery(window).ready(function () {
		initStickNavigation(sticky, navbar, space_between_banner_and_sticky);
	});
	jQuery(window).scroll(function () {
		initStickNavigation(sticky, navbar, space_between_banner_and_sticky);
	});
	jQuery(window).resize(function () {
		initStickNavigation(sticky, navbar, space_between_banner_and_sticky);
	});
}

function initStickNavigation(sticky, navbar, space_between_banner_and_sticky) {


	if (getBrowserWidth() <= 1000) {
		sticky.removeClass('position-fixed');
		sticky.removeClass('position-absolute');
		sticky.css({ 'top': '', 'bottom': '', 'width': '' });

		return false;
	}

	var top_of_container_grid = jQuery('.sticky-form-inside').offset().top;
	var bottom_of_container_grid = jQuery('.sticky-form-inside').offset().top + jQuery('.sticky-form-inside').outerHeight();
	var top_of_screen = jQuery(window).scrollTop() + navbar.outerHeight();
	var sticky_width = sticky.outerWidth();
	var sticky_height = sticky.outerHeight();

	// if (sticky.hasClass('position-absolute') && jQuery('.sticky-form-inside .wpb_wrapper').offset().top > (top_of_screen + space_between_banner_and_sticky)) {
	// 	sticky.removeClass('position-absolute');
	// }

	if (top_of_screen > bottom_of_container_grid - (sticky_height + space_between_banner_and_sticky)) {
		//if ((jQuery('.sticky-form-inside .wpb_wrapper').offset().top + sticky_height) > (bottom_of_container_grid - 1)) {
		sticky.addClass('position-absolute');
		sticky.removeClass('position-fixed');
		sticky.css({ 'bottom': 0, 'top': '', 'width': sticky_width });
	}
	else if (top_of_screen > (top_of_container_grid - space_between_banner_and_sticky)) {
		sticky.addClass('position-fixed');
		sticky.removeClass('position-absolute');
		sticky.css({ 'top': (navbar.outerHeight() + space_between_banner_and_sticky), 'bottom': '', 'width': sticky_width });
	}
	else if ((sticky.hasClass('position-fixed')) && (top_of_screen < (top_of_container_grid - space_between_banner_and_sticky))) {
		sticky.removeClass('position-fixed');
		sticky.removeClass('position-absolute');
		sticky.css({ 'top': '', 'bottom': '', 'width': '' });
	}
}

function preventTransparentNavbar() {
	if (jQuery('body').hasClass('single-carehome') ||
		jQuery('body').hasClass('single-portfolio') ||
		jQuery('body').hasClass('archive') ||
		jQuery('body').hasClass('single-post')) {
		return true;
	}

	return false;
}

function addTransparentHeaderDataAttribute() {
	jQuery('#header-outer').attr('data-transparent-header', 'true');
	jQuery('#header-outer').addClass('transparent');
	jQuery('#header-space').addClass('hidden');
}

function removeTransparentClassOnScroll() {
	if (jQuery(window).scrollTop() > 150) {
		jQuery('#header-outer').removeClass('transparent');
	} else {
		jQuery('#header-outer').addClass('transparent');
	}
}

function addLogoVariants() {
	// White version of logo is not being added to custom pages, so need to add this through JS instead of relying on theme
	//jQuery('#logo').html('<img class="stnd default-logo" alt="Evolve" src="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif" srcset="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif 1x, /app/uploads/2019/11/Evolve-logo-WEB-v3.gif 2x"><img class="starting-logo mobile-only-logo" alt="Evolve" src="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif"><img class="starting-logo dark-version mobile-only-logo" alt="Evolve" src="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif"><img class="starting-logo default-logo" alt="Evolve" src="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif" srcset="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif 1x, /app/uploads/2019/11/Evolve-logo-WEB-v3.gif 2x"><img class="starting-logo dark-version default-logo" alt="Evolve" src="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif" srcset="/app/uploads/2019/11/Evolve-logo-WEB-v3.gif 1x, /app/uploads/2019/11/Evolve-logo-WEB-v3.gif 2x">');
	jQuery('#logo').html('<img class="stnd default-logo" alt="Knights Care" src="/app/uploads/2020/01/main-logo-small.png" srcset="/app/uploads/2020/01/main-logo-small.png 1x, /app/uploads/2020/01/main-logo.png 2x"><img class="starting-logo mobile-only-logo" alt="Knights Care" src="/app/uploads/2020/01/main-logo-small.png"><img class="starting-logo dark-version mobile-only-logo" alt="Knights Care" src="/app/uploads/2020/01/main-logo-small.png"><img class="starting-logo default-logo" alt="Knights Care" src="/app/uploads/2020/01/main-logo-small.png" srcset="/app/uploads/2020/01/main-logo-small.png 1x, /app/uploads/2020/01/main-logo.png 2x"><img class="starting-logo dark-version default-logo" alt="Knights Care" src="/app/uploads/2020/01/main-logo-small.png" srcset="/app/uploads/2020/01/main-logo-small.png 1x, /app/uploads/2020/01/main-logo.png 2x"> ');
}

function init() {

	//remove sticky contact form, since sometimes this does not fit on laptop devices
	/*if (!environment.isMobile()) {
		toggleStickyNavigation();
	}*/

	jQuery('.link-unclickable > a').click(function (e) {
		e.preventDefault;
		return false;
	});

	if (preventTransparentNavbar()) {
		addTransparentHeaderDataAttribute();
		addLogoVariants();
	}

	jQuery(window).scroll(function () {
		if (preventTransparentNavbar()) {
			removeTransparentClassOnScroll();
		}
	});
}

jQuery(document).ready(function () {
	init();
});


// WEBPACK FOOTER //
// ./assets/js/app.js